import React from 'react';
import styles from './index.module.scss';
import { blobUrl } from '../../../../helpers';

const ImageOnly = ({ image }) => <img className={styles.image} src={blobUrl(image)} alt='' />;

export default ImageOnly;
